export const INIT_GRAPH_REQUEST = "INIT_GRAPH_REQUEST";
export const INIT_GRAPH_SUCCESS = "INIT_GRAPH_SUCCESS";
export const INIT_GRAPH_FAILED = "INIT_GRAPH_FAILED";

export const SET_START_VERTEX = "SET_START_VERTEX";

export const EDIT_START_VERTEX_TOGGLE = "EDIT_START_VERTEX_TOGGLE";
export const EDIT_START_VERTEX_SUCCESS = "EDIT_START_VERTEX_SUCCESS";
